import { render } from "./ContactOverview.vue?vue&type=template&id=49076f51&scoped=true"
import script from "./ContactOverview.vue?vue&type=script&lang=js"
export * from "./ContactOverview.vue?vue&type=script&lang=js"

import "./ContactOverview.vue?vue&type=style&index=0&id=49076f51&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49076f51"],['__file',"src/views/h5/crm/contact/ContactOverview.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "49076f51"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('49076f51', __exports__)) {
    api.reload('49076f51', __exports__)
  }
  
  module.hot.accept("./ContactOverview.vue?vue&type=template&id=49076f51&scoped=true", () => {
    api.rerender('49076f51', render)
  })

}


export default __exports__